module.exports = __webpack_public_path__ + "static/media/Universitas Kristen Petra.e4624e08.png";